import { ScrollReveal } from './scroll-reveal'

/* FAQ, a quiet, border-divided list of the questions a studio asks first. */

export const FAQS = [
  {
    a: 'O Planno é a ferramenta profissional para escritórios de arquitetura, interiores e engenharia que tocam vários projetos ao mesmo tempo e hoje se viram entre e-mail, WhatsApp, Drive e planilhas. Funciona de um arquiteto solo a equipes de quinze pessoas.',
    q: 'Para quem é o Planno?',
  },
  {
    a: 'Não. Dá para começar só pelas tarefas de um projeto e trazer o resto no seu ritmo. WhatsApp, Gmail, Google Drive e Agenda continuam funcionando, conectados ao Planno.',
    q: 'Preciso migrar tudo de uma vez?',
  },
  {
    a: 'Sim, esse é o ponto. Visitas técnicas, checklists, fotos, pendências de campo e diário de obra ficam no mesmo lugar das pranchas, das tarefas e do financeiro do projeto.',
    q: 'O Planno serve para a obra, não só para o projeto?',
  },
  {
    a: 'Você lança os custos fixos do escritório, as horas ativas da equipe, os impostos e a reserva de margem. O Planno calcula a hora técnica em tempo real e usa esse número como base para cada orçamento. Mudou um custo? O preço das propostas pendentes muda junto.',
    q: 'Como funciona a precificação por hora técnica?',
  },
  {
    a: 'Sim, pela API oficial do WhatsApp Business. Você conversa com o assistente do Planno no seu WhatsApp: pergunta o que ficou pendente na visita, como está o sprint ou o que andou em um projeto, e cria tarefas, clientes e outros registros ali mesmo na conversa. O que você pede entra no escritório com o projeto e o responsável certos.',
    q: 'A integração com WhatsApp é oficial?',
  },
  {
    a: 'Resume o andamento de qualquer projeto, rascunha memoriais, termos de aprovação, e-mails e propostas a partir do briefing, revisa contratos contra o checklist jurídico do escritório e gera renders realistas a partir de prints do SketchUp.',
    q: 'O que a IA do Planno consegue fazer?',
  },
  {
    a: 'Sim. CPF, CNPJ, contratos e plantas são tratados com cuidado de dados sensíveis: criptografia em trânsito e em repouso, log de auditoria completo, conformidade com a LGPD e exportação completa quando você quiser sair.',
    q: 'Meus dados e os dos meus clientes estão seguros?',
  },
  {
    a: 'Sim. O Planno instala como app no celular, funciona offline em visitas técnicas e sincroniza fotos e anotações quando o sinal volta.',
    q: 'Funciona no celular, em obra com sinal ruim?',
  },
]

export const FaqSection = () => (
  <section className="bg-white py-28">
    <div className="mx-auto max-w-[820px] px-6">
      <ScrollReveal>
        <h2 className="text-center font-display text-[#0b0b0d] text-[clamp(34px,5vw,50px)] tracking-[-0.01em]">
          Perguntas frequentes
        </h2>
      </ScrollReveal>

      <div className="mt-14">
        {FAQS.map((faq) => (
          <ScrollReveal key={faq.q}>
            <div className="border-[#ececec] border-t py-7 last:border-b">
              <h3 className="font-semibold text-[#0b0b0d] text-[clamp(17px,2.2vw,20px)]">
                {faq.q}
              </h3>
              <p className="mt-2.5 max-w-[640px] text-[#8a8a90] text-[clamp(15px,2vw,17px)] leading-relaxed">
                {faq.a}
              </p>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
)
